/* MUI */
import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    Paper,
    TextField,
    Typography
} from '@mui/material';

/* Shared */
import { PartnerBackButton } from 'application/Shared/Components/Buttons/BackButton';
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';
import { Notify } from 'application/Shared/Helpers';
import Core from 'application/Shared/Helpers/Functions';
import { Requests } from 'application/Shared/Requests';

/* NPM */
import axios from 'axios';

/* Hooks */
import { getUserTheme } from 'hooks/dataAccess/User/userTheme';

/* React */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class GenericEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        };

        /* requests */
        this.requests = new Requests();
    }

    async componentDidMount() {
        const state = { loaded: true };
        try {
            const response = await axios.get('/integrations', {
                cancelToken: this.requests.token(),
                params: { key: 'generic_email' }
            });

            if (Core.isset(response, 'data', 'data', 0)) {
                state.fields = response.data.data;

                state.fields.forEach((field) => {
                    if (field.value !== null) {
                        state[field.fieldKey] = field.value;
                    } else {
                        state[field.fieldKey] = field.default;
                    }
                });
            }
        } catch (err) {
            // Notify.error(this.props.t('Common.error'));
        }

        this.setState(state);
    }

    componentWillUnmount() {
        this.unload();
    }

    unload = () => {
        this.requests.cancel();
    };

    save = () => {
        const { t } = this.props;
        const { fields } = this.state;

        fields.forEach(async (field) => {
            const key = field?.fieldKey;
            if (key) {
                const { [key]: stateFieldKey } = this.state;
                const payload = {
                    field: field.fieldKey,
                    key: 'generic_email',
                    value: stateFieldKey
                };
                await axios.post('/integrations/', payload);
            }
        });

        Notify.success(t('PartnerIntegration.save_successful'));
    };

    render() {
        const { session, t } = this.props;
        const { fields, loaded } = this.state;
        const userTheme = getUserTheme(session?.user?.theme);

        if (!loaded) {
            return null;
        }

        return (
            <>
                <Box width="100%">
                    <Typography variant="h3">
                        {t('ClientSettings.title')}
                    </Typography>
                    <hr />
                </Box>
                <PartnerBackButton
                    linkTo="/integrations/partnerLevel"
                    textOverride="Integrations.Common.back"
                />
                <Paper elevation={0} variant="outlined">
                    <Grid container spacing={0}>
                        <img
                            src={`/images/${userTheme}/integrations/generic_email.png`}
                            alt={t('Integrations.supportInbox.logo')}
                            style={{
                                paddingBottom: '32px',
                                paddingTop: '32px',
                                width: '200px'
                            }}
                        />
                        <br />
                        <br />
                        {fields.map((field) => {
                            const { [field?.fieldKey]: stateFieldKey } =
                                this.state;
                            return (
                                <Grid item xs={12} key={field.fieldKey}>
                                    {field.type !== 'boolean' && (
                                        <Box display="flex" alignItems="center">
                                            <Typography
                                                color="textSecondary"
                                                fontWeight={600}
                                            >
                                                {t(field.label)}
                                            </Typography>
                                            <TooltipQ
                                                text={t(field.tooltip)}
                                                size={FontSizes[1]}
                                            />
                                        </Box>
                                    )}
                                    {field.type === 'boolean' && (
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            mb="24px"
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={stateFieldKey}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                [field.fieldKey]:
                                                                    e.target
                                                                        .checked
                                                            })
                                                        }
                                                        label={t(field.label)}
                                                    />
                                                }
                                            />
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                            >
                                                {t(field.label)}
                                                <TooltipQ
                                                    text={t(field.tooltip)}
                                                    size={FontSizes[1]}
                                                />
                                            </Box>
                                        </Box>
                                    )}
                                    {(field.type === 'text' ||
                                        field.type === 'email') && (
                                        <>
                                            <TextField
                                                onChange={(e) => {
                                                    this.setState({
                                                        [field.fieldKey]:
                                                            e.target.value
                                                    });
                                                }}
                                                value={stateFieldKey}
                                                style={{ width: 300 }}
                                            />
                                            <br />
                                            <br />
                                        </>
                                    )}
                                </Grid>
                            );
                        })}
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <hr />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                data-trackid="integrationsGenericEmailSaveBtn"
                                color="primary"
                                onClick={() => this.save()}
                                style={{ float: 'right' }}
                                variant="contained"
                            >
                                {t('Common.save_settings')}
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </>
        );
    }
}
export default withTranslation()(GenericEmail);
